<template>
  <div class="flex flex-col items-center text-center gap-6 py-12 sm:py-16 px-4 sm:px-10 max-w-2xl mx-auto bg-white rounded-xl border border-gray-200 shadow-sm">

    <div class="flex-shrink-0 h-14 w-14 rounded-full bg-green-100 flex items-center justify-center">
      <svg class="w-7 h-7 text-green-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    </div>

    <div class="flex flex-col gap-3">
      <h1 class="text-2xl sm:text-3xl font-extrabold text-gray-900">
        <template v-if="hasDonated">Thank you for your contribution.</template>
        <template v-else>You're all set.</template>
      </h1>

      <p class="text-gray-700 text-base sm:text-lg">
        <template v-if="hasDonated">Your payment of {{ normalizedAmount | toCurrency }} was successful.</template>
        <template v-else>Your protest is complete and there is nothing you are required to pay.</template>
      </p>

      <p v-if="hasDonated && userEmail" class="text-gray-600 text-sm sm:text-base">
        We've emailed your payment receipt to <span class="font-medium text-gray-900">{{ userEmail }}</span>
      </p>

      <p class="text-gray-600 text-sm sm:text-base leading-relaxed">
        <template v-if="hasDonated">
          I really appreciate your support. Your contribution helps cover the cost of providing this service and
          helps us keep the required fee at $0 for the next homeowner.
        </template>
        <template v-else>
          Thank you for trusting us with your property tax protest. I'm grateful for the opportunity to help.
        </template>
      </p>

      <p v-if="!hasDonated" class="text-gray-500 text-sm">Returning you to your dashboard...</p>
    </div>

    <a :href="dashboardUrl"
      class="w-full max-w-xs inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-3 bg-indigo-600 font-semibold text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-sm">
      Go to Dashboard
    </a>

    <p class="text-xs text-gray-500">
      Have feedback, a question, or something we should know?
      <a :href="feedbackUrl" class="text-indigo-600 hover:text-indigo-700 font-medium underline">Tell us here.</a>
    </p>

  </div>
</template>

<script>
export default {
  name: 'DonationThankYou',

  props: {
    donationAmount: {
      type: [Number, String],
      default: 0
    },
    userEmail: {
      type: String,
      default: ''
    },
    dashboardUrl: {
      type: String,
      default: '/user-properties'
    },
    feedbackUrl: {
      type: String,
      default: ''
    }
  },

  computed: {
    normalizedAmount() {
      return Number(this.donationAmount) || 0;
    },
    hasDonated() {
      return this.normalizedAmount > 0;
    }
  },

  mounted() {
    // $0 (no donation): auto-return to the dashboard after a few seconds.
    // Paid donations stay on this page - the user may want to read the receipt info.
    if (!this.hasDonated) {
      setTimeout(() => {
        window.location.href = this.dashboardUrl;
      }, 3500);
    }
  }
}
</script>
